import { fetchVoiceLibrary, type VoiceLibraryResponse } from "@/lib/voices-api"

// Кеш каталога на сессию фронта (сервер сам кеширует с TTL и инвалидацией по
// подключению провайдера). Общий для всех потребителей — voice-picker и секции
// голосов героя, иначе одна страница слала бы два одинаковых запроса.
// Ошибки не кешируем: следующая попытка снова идёт на сервер.
const libraryCache = new Map<number, Promise<VoiceLibraryResponse>>()

export function loadVoiceLibrary(projectId: number): Promise<VoiceLibraryResponse> {
  let promise = libraryCache.get(projectId)
  if (!promise) {
    promise = fetchVoiceLibrary(projectId)
    promise.catch(() => libraryCache.delete(projectId))
    libraryCache.set(projectId, promise)
  }
  return promise
}

/** Неполный каталог (часть провайдеров сбоила) успехом не считается — даём повторить. */
export function dropVoiceLibraryCache(projectId: number) {
  libraryCache.delete(projectId)
}
